module.exports = __webpack_public_path__ + "media/images/placeholders/entity_placeholder@2x-46e6969873ed74ef912c9d85b89e93c2.png";